import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../contexts/AuthContext'

export function useMerchant() {
  const { user, loading: authLoading } = useAuth()
  const [merchant, setMerchant] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (authLoading) return

    if (!user) {
      setMerchant(null)
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)
    async function fetchMerchant() {
      const { data, error: fetchError } = await supabase
        .from('merchants')
        .select('*')
        .eq('user_id', user.id)
        .order('onboarding_done', { ascending: false })
        .order('created_at', { ascending: false })
        .limit(1)
        .maybeSingle()

      if (fetchError) {
        setError(fetchError.message)
      } else {
        setMerchant(data)
      }
      setLoading(false)
    }

    fetchMerchant()
  }, [user, authLoading])

  const updateMerchant = async (updates) => {
    if (!merchant) return
    const { data, error: updateError } = await supabase
      .from('merchants')
      .update(updates)
      .eq('id', merchant.id)
      .select()
      .single()

    if (!updateError) setMerchant(data)
    return { data, error: updateError }
  }

  return { merchant, loading, error, updateMerchant }
}
